/**
 * AUTH REQUESTS
 */
import { LOGIN_URL, ME_URL, EMAIL_CONFIRMATION, CHECK_RESET_TOKEN, FORGOT_PASSWORD, RESET_PASSWORD, SEND_AUTH_CODE, CHECK_AUTH_CODE, RENEW_TOKEN, GET_LINK_WITH_DOCTOR, SEND_AUTH_CODE_BY_SMS} from '../apiUrl'
import Axios from './axiosSetup';

/**
 * Login patient Request
 * @param {identifier, password} formData 
 * @returns 
 */
export const LoginRequest = async (formData: { identifier: string; password: string; language: string; }) => {
  if(sessionStorage.getItem('jwtToken') !== null) {
    Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  }else{
    delete Axios.defaults.headers.common.Authorization
  }
  const { identifier, password, language } = formData
  return Axios.post(LOGIN_URL, { identifier, password, language });
}

/**
 * Get User By Token 
 * @returns 
 */
export function GetMe() {
  if(sessionStorage.getItem('jwtToken') !== null) {
    Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  }
  return Axios.get(ME_URL);
}

/**
 * Get email confirmation by token
 * @returns 
 */
export function GetEmailConfirmation(token: string) {
  return Axios.get(`${EMAIL_CONFIRMATION}?confirmation=${token}`);
}

/**
 * Get email confirmation by token
 * @returns 
 */
export function CheckResetToken(token: string) {
  return Axios.get(`${CHECK_RESET_TOKEN}?token=${token}`);
}

/**
 * Forgot Password Request
 * @param {email} formData 
 * @returns 
 */
export const ForgotPasswordRequest = async (formData: { email: string }) => {
  const { email } = formData
  return Axios.post(`${FORGOT_PASSWORD}`, { email });
}

/**
 * Get Link With Doctor Request
 * @param patient_uid
 * @param doctor_uid
 * @returns 
 */
export const GetLinkWithDoctor = async (patient_uid: string, doctor_uid: string) => {
  return Axios.post(`${GET_LINK_WITH_DOCTOR}`, {
    patient_uid: patient_uid,
    doctor_uid: doctor_uid
  });
}

/**
* Reset Password
* @param {PasswordProps, passwordConfirmation, code} formData 
* @returns 
*/
export function ResetPasswordRequest(formData: object) {
  return Axios.post(`${RESET_PASSWORD}`, formData);
}

/**
 * Send Auth code
 * @returns 
 */
export function SendAuthCode(email: string) {
  return Axios.post(`${SEND_AUTH_CODE}`, {email});
}

/**
 * Send Auth code
 * @returns 
 */
export function SendAuthCodeBySMS(email: string, phone_number: string, token?: string) {
  return Axios.post(`${SEND_AUTH_CODE_BY_SMS}`, {email, phone_number, token});
}

/**
 * Check Auth code
 * @returns 
 */
export function CheckAuthCode({ code, email, token }: any) {
  return Axios.post(`${CHECK_AUTH_CODE}`, { code, email, token });
}

/**
 * Renew Token
 * @returns 
 */
export function RenewToken() {
  if(sessionStorage.getItem('jwtToken') !== null) {
    Axios.defaults.headers.common.Authorization = `Bearer ${sessionStorage.getItem('jwtToken')}`;
  }
  return Axios.get(RENEW_TOKEN);
}